import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useAppContext } from 'providers/appProvider';
import axios from "axios";

const ToggleButton = () => {
  const {
    config: { isNavbarVerticalCollapsed },
    setConfig
  } = useAppContext();

  const [navbarVerticalCollapsedToggle, SetNavbarVerticalCollapsedToggle] = useState(isNavbarVerticalCollapsed);
  const [userData, setUserData] = useState();
  const [userId, setUserId] = useState();

  const fetchUser = async (userId) => {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/userRoute/getUserById/${userId}`,{
        headers: {
          Authorization: process.env.REACT_APP_BasicAuthSecret
        }
      }
    );
    const navbarVerticalCollapsedToggleData = response ? response.data.NavbarVerticalCollapsedToggle : navbarVerticalCollapsedToggle;
    setConfig('isNavbarVerticalCollapsed', navbarVerticalCollapsedToggleData);
    SetNavbarVerticalCollapsedToggle(navbarVerticalCollapsedToggleData);
    setUserData(response ? response.data : null);
  };

  useEffect(() => {
    const userId = localStorage.getItem("UserId");
    setConfig('isNavbarVerticalCollapsed', navbarVerticalCollapsedToggle);
    setUserId(userId);
    fetchUser(userId);
  }, []);

  const handleClick = async () => {
    const navbarVerticalCollapsedToggleNewValue = !navbarVerticalCollapsedToggle;
    document
      .getElementsByTagName('html')[0]
      .classList.toggle('navbar-vertical-collapsed');

    SetNavbarVerticalCollapsedToggle(navbarVerticalCollapsedToggleNewValue);
    setConfig('isNavbarVerticalCollapsed', navbarVerticalCollapsedToggleNewValue);
    userData.navbarVerticalCollapsedToggle = navbarVerticalCollapsedToggleNewValue;

    await axios.patch(
      `${process.env.REACT_APP_API_URL}/userRoute/updateUser/${userId}`,
      userData,{
        headers: {
          Authorization: process.env.REACT_APP_BasicAuthSecret
        }
      }
    );
  };

  return (
    <div className="toggle-icon-wrapper">
      <Button
        variant="link"
        className="navbar-toggler-humburger-icon navbar-vertical-toggle"
        id="toggleNavigationTooltip"
        onClick={handleClick}
      >
        <span className="navbar-toggle-icon">
          <span className="toggle-line" />
        </span>
      </Button>
    </div>
  );
};

export default ToggleButton;
